import _ from '@/utils/lodash-optimized'

import { AlertToast } from './alert-toast'
import { CarePlanToast } from './care-plan-toast'
import { EligibleToast } from './eligible-toast'
import { FileToast } from './file-toast'
import { IgaoToast } from './igao-toast'
import { MessageToast } from './message-toast'
import { SymptomToast } from './symptom-toast'

export const toastSlicer = (t, i, close) => {
  const props = {
    key: `toast-stack-${i}`,
    index: i,
    close
  }

    Object.keys(t?.payload ?? {}).forEach(k => {
    props[_.camelCase(k)] = t.payload[k]
  })

  Object.keys(t).forEach(k => {
    props[_.camelCase(k)] = t[k]
  })

  const { message, attachmentName } = props

  if (message || attachmentName) {
    props.message =
      message
        ? message.length >= 110 ? message.slice(0, 107).concat('...') : message
        : attachmentName
  }

  // id from toast is needed for correct close, even undefined
  props.id = t.id

  if (t.type === 'alert') {
    return <AlertToast {...props} />
  }
  if (t.type === 'alert_escalated') {
    return <AlertToast {...props} />
  }
  if (t.type === 'message') {
    return (
      <MessageToast
        {...props}
        isConcierge={props.chat?.meta?.concierge === true}
      />
    )
  }
  if (t.type === 'issue_assigned') {
    return <CarePlanToast {...props} />
  }
  if (t.type === 'igao_published') {
    return <IgaoToast {...props} />
  }
  if (t.type === 'patient_ineligible') {
    return <EligibleToast {...props} />
  }
  if (t.type === 'symptoms_reported') {
    return <SymptomToast {...props} />
  }
  if (t.type === 'new_file') {
    return <FileToast {...props} />
  }
  return null
}

export * from './toast-stack'
